import { render, staticRenderFns } from "./modal-viewer-receita.vue?vue&type=template&id=3ed3c6f5&scoped=true&"
import script from "./modal-viewer-receita.vue?vue&type=script&lang=js&"
export * from "./modal-viewer-receita.vue?vue&type=script&lang=js&"
import style0 from "./modal-viewer-receita.vue?vue&type=style&index=0&id=3ed3c6f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3c6f5",
  null
  
)

export default component.exports